// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  imported from Specs.module.scss  */
.Specs-module-Root_2Xv {
  font-family: var(--specs-font-family); }

.Specs-module-Item_2lP {
  display: flex;
  justify-content: space-between;
  align-items: center;
  min-height: 3rem;
  font-size: 1rem;
  line-height: 1.25;
  border-bottom: 1px var(--specs-border-bottom) solid; }

.Specs-module-Name_6kx {
  padding-right: 0.5rem;
  color: var(--specs-name-color); }
  .Specs-module-Name_6kx::after {
    content: ':'; }

.Specs-module-Value_Wph {
  margin-top: 0.3rem;
  margin-bottom: 0.3rem;
  text-align: right; }
`, "",{"version":3,"sources":["webpack://./node_modules/@npm-registry/eapteka-ui/es/components/Specs/Specs.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,qCAAqC,EAAE;;AAEzC;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,mDAAmD,EAAE;;AAEvD;EACE,qBAAqB;EACrB,8BAA8B,EAAE;EAChC;IACE,YAAY,EAAE;;AAElB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB,EAAE","sourcesContent":["/*  imported from Specs.module.scss  */\n.Specs-module-Root_2Xv {\n  font-family: var(--specs-font-family); }\n\n.Specs-module-Item_2lP {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  min-height: 3rem;\n  font-size: 1rem;\n  line-height: 1.25;\n  border-bottom: 1px var(--specs-border-bottom) solid; }\n\n.Specs-module-Name_6kx {\n  padding-right: 0.5rem;\n  color: var(--specs-name-color); }\n  .Specs-module-Name_6kx::after {\n    content: ':'; }\n\n.Specs-module-Value_Wph {\n  margin-top: 0.3rem;\n  margin-bottom: 0.3rem;\n  text-align: right; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
